import QuestionPreview from '../question-selector/src/quesView.vue';

/* istanbul ignore next */
QuestionPreview.install = function(Vue) {
  Vue.component(QuestionPreview.name, QuestionPreview);
};

export default QuestionPreview;
